export const remap = (
  obj: { [key: string]: any },
  mapper: (obj: { [key: string]: any }) => { [key: string]: any } | undefined,
) => obj ? ({...obj, ...mapper(obj)}) : obj
